import L from 'leaflet';

// Ícone do Campus / Escola com a cor Vermelha Institucional do IFSP
export const SchoolLocationIcon = L.divIcon({
  className: 'ifsp-school-marker',
  html: `
    <div style="
      background-color: #D32F2F;
      width: 34px;
      height: 34px;
      border-radius: 50%;
      border: 3px solid #FFFFFF;
      box-shadow: 0 3px 8px rgba(0,0,0,0.35);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      cursor: pointer;
    ">
      🎓
    </div>
  `,
  iconSize: [34, 34],
  iconAnchor: [17, 17], // Centraliza o ícone exatamente nas coordenadas
  popupAnchor: [0, -18]  // Abre o popup logo acima do ícone
});

// Ícone Secundário / Centro de Pesquisa (opcional)
export const ResearchCenterIcon = L.divIcon({
  className: 'ifsp-research-marker',
  html: `
    <div style="
      background-color: #028436;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      border: 2px solid #FFFFFF;
      box-shadow: 0 2px 6px rgba(0,0,0,0.3);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      cursor: pointer;
    ">
      🔬
    </div>
  `,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  popupAnchor: [0, -15]
});